// modifer: styles/jss/nextjs-material-kit-pro/pages/profilePageStyle
import { cardTitle, coloredShadow, boxShadow } from 'styles/jss/original/base';

import imagesStyle from 'styles/jss/nextjs-material-kit-pro/imagesStyles.js';

const styles = {
  card: {
    textAlign: 'left !important',
    border: '1px solid #e0e0e0',
    ...boxShadow,
    '@media (max-width: 640px)': {
      marginTop: '10px'
    }
  },
  coloredShadow,
  cardTitle,
  ...imagesStyle,
  flexItem: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    marginLeft: '-15px',
    '@media (max-width: 768px)': {
      marginLeft: '0px'
    }
  }
};

export default styles;
